// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__3hPAS","dragIcon":"Choice_dragIcon__LaCA-","left":"Choice_left__tcUAt","input":"Choice_input__2sjQm"};